import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading, text" theme="light" className="titleBlock-align-left" mdxType="TitleBlock" />
    <h2 {...{
      "id": "start-embedding-pdfs-in-a-few-minutes"
    }}>{`Start embedding PDFs in a few minutes`}</h2>
    <p>{`Adobe PDF Embed API is free to use, so get started today!`}</p>
    <TextBlock slots="heading, text, buttons" width="33%" theme="light" className="align-left horizontal-align" mdxType="TextBlock" />
    <h3 {...{
      "id": "step-1"
    }}>{`Step 1`}</h3>
    <p>{`Obtain free credentials`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://acrobatservices.adobe.com/dc-integration-creation-app-cdn/main.html?api=pdf-embed-api"
        }}>{`Get started`}</a></li>
    </ul>
    <TextBlock slots="heading, text, buttons" width="33%" theme="light" className="align-left horizontal-align" variantsTypePrimary='secondary' variantsTypeSecondary='secondary' variantStyleFill="outline" variantStyleOutline="outline" isPrimaryBtn primaryOutline mdxType="TextBlock" />
    <h3 {...{
      "id": "step-2"
    }}>{`Step 2`}</h3>
    <p>{`Copy JavaScript code or download samples for React and Angular`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/document-services/docs/overview/pdf-embed-api/"
        }}>{`Get JavaScript`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/adobe/pdf-embed-api-samples"
        }}>{`Get Samples`}</a></li>
    </ul>
    <TextBlock slots="heading, text, buttons" width="33%" theme="light" className="align-left horizontal-align" mdxType="TextBlock" />
    <h3 {...{
      "id": "step-3"
    }}>{`Step 3`}</h3>
    <p>{`Add credentials to your code and run!`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/document-services/docs/overview/pdf-embed-api/"
        }}>{`See documentation`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      